export default {
  SET_APPROVALS_DETAILS(state, payload) {
    state.approvalDetails = payload;
  }
};
